<template>
    <div class="confirm-email">
        <div class="align-self-center text-center">
            <h1>Recover password</h1>
            <p class="text-subheading">Forgot your password? No worries, we'll email you a link to choose a new one.</p>
        </div>
        <b-form
            @submit.prevent="$emit('submit')"
        >
            <b-form-group>
                <b-input-group>
                    <b-input-group-prepend>
                        <span class="input-group-text-coherent">
                            <i class="far fa-at"/>
                        </span>
                    </b-input-group-prepend>
                    <b-form-input
                        class="form-control-coherent"
                        :value="value.email"
                        @input="onEmailChange"
                        placeholder="Enter your email address"
                        type="text"
                    />
                </b-input-group>
                <template v-if="errors.length">
                    <b-form-invalid-feedback
                        :key="errIndex"
                        class="d-block"
                        v-for="(error, errIndex) in errors"
                    >
                        <i class="fal fa-exclamation-circle"/>
                        {{ error }}
                    </b-form-invalid-feedback>
                </template>
            </b-form-group>
            <b-form-group>
                <b-btn
                    :disabled="loading"
                    block
                    size="lg"
                    type="submit"
                    variant="primary"
                    id="submit-button"
                >
                    Continue
                </b-btn>
            </b-form-group>
        </b-form>
    </div>
</template>

<script>
export default {
    name: 'ConfirmEmail',
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({})
        },
        errors: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
        },
    },
    data: () => ({}),
    methods: {
        onInput(value) {
            this.$emit('input', this.value);
        },
        onEmailChange(value) {
            this.value.email = value;
            this.onInput(value);
        }
    }
}
</script>